import { render, staticRenderFns } from "./IaAttachment.vue?vue&type=template&id=d01f3e78&scoped=true&"
import script from "./IaAttachment.vue?vue&type=script&lang=js&"
export * from "./IaAttachment.vue?vue&type=script&lang=js&"
import style0 from "./IaAttachment.vue?vue&type=style&index=0&id=d01f3e78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01f3e78",
  null
  
)

export default component.exports